import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { TransfersPage } from './TransfersPage';

const searchSchema = z.object({
  month: z.string().optional(),
});

export const Route = createFileRoute('/_protected/_consumer/transaction-overview/transfers/')({
  component: TransfersPage,
  validateSearch: searchSchema,
});
